import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=2c134cd2&scoped=true&"
import script from "./ModalSuccess.vue?vue&type=script&lang=js&"
export * from "./ModalSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuccess.vue?vue&type=style&index=0&id=2c134cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c134cd2",
  null
  
)

export default component.exports